const { BaseURl } = require("./BaseApiUrl")

export const uploadColdAllAPIURL = BaseURl + "ColdCalls/UploadColdCalls/v1/";